
import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { LMFormComponent } from '@form/lm-form.component';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';
@Component({
  selector: 'lm-response-required',
  template: `
    <lm-form #lmrequiredresponse *ngIf="formSpec"
        [formUrlInfo]="formUrlInfo"
        [formSpec]="formSpec"
        [initDataView]="dataView"
        [formOptions]="formOptions"
        [ngStyle]="{'height': '100%'}"
    >
    </lm-form>
  `
})

export class LMResponseRequiredModalFormComponent {
  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() dataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() defaultButton: SohoModalButton;

  @ViewChild(forwardRef(() => LMFormComponent)) formComponent: LMFormComponent;

  @HostListener('keydown',['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.defaultButton) {
      const eventTarget: HTMLElement = event.target as HTMLElement;
      if (this.lmKeyboardShortcutService.onKeyDown(event) === LMKeyType.SAVE
      || (event.code === 'Enter'
         && eventTarget?.tagName !== 'BUTTON'
         && eventTarget?.tagName !== 'A'
         && eventTarget?.tagName !== 'TEXTAREA'
         && !eventTarget?.hasAttribute('soho-editor'))) {

        //need to trigger the blur event to trigger the field's change event
        eventTarget.blur();
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.defaultButton.click(null,null);
      }
    }
  }

  constructor(private changeDetectionRef: ChangeDetectorRef, private lmKeyboardShortcutService: LMKeyboardShortcutService) {}

  triggerDetectChanges() {
    this.changeDetectionRef.markForCheck();
  }
}
